<template>
  <owal-button
    :identifier="identifier"
    :corners="corners"
    @click="cycle"
  >
    <div>
      {{ this.activeState.title }}
      <font-awesome-icon
        v-if="this.icon"
        slot="accessory"
        key="accessory"
        :icon="this.icon"
      />
    </div>
  </owal-button>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import OwalButton from './OwalButton'

export default {
  name: 'OwalButtonMultistate',
  components: {
    FontAwesomeIcon,
    OwalButton,
  },
  extends: OwalButton,
  props: {
    /**
     * An array of OwalButtonConfiguration objects.
     * When the user clicks, the button activates the next state in the sequence.
     */
    states: {
      type: Array,
      default: () => [],
    },
  },
  data () {
    return {
      activeStateIndex: 0,
    }
  },
  computed: {
    activeState () {
      return this.states[this.activeStateIndex]
    },
    icon () {
      const icon = this.activeState.icon
      return icon
    },
  },
  methods: {
    cycle () {
      this.activeStateIndex += 1
      if (this.activeStateIndex === this.states.length) {
        this.activeStateIndex = 0
      }
      this.$emit('click', this.activeState)
    },
  },
}
</script>

<style scoped>

</style>
